/**
 * Z-index master list
 * These are used for a bird's eye view of components
 * dependent on the z-axis and are designed to all work together.
 */
export default {
  navigation: 1000,
  buttonMenu: 1001,
  pageHeader: 1010,
  desktopHeader: 1020,
  mobileHeader: 1030,
  drawer: 1040,
  notifications: 1050,
  sideNav: 1060,
  tooltip: 1070,
  dropdown: 1070
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/zIndex.js
// module id = 525
// module chunks = 0